import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/teachers/TeacherDashboard.css";
import { FaBell, FaClock, FaUpload, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import TeacherAttendanceGraph from "../../../subscreens/TeacherAttendanceGraph/TeacherAttendanceGraph";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";
import { BookOpen, FileText} from "lucide-react";

const TeacherDashboard = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [showNotifications, setShowNotifications] = useState(false);
  const { loggedInTeacher } = useContext(AppContext);

  const notifications = [
    "Exam schedule has been updated",
    "Attendance QR generated (10 mins)",
    "New result submission request",
  ];
 const [dashboard, setDashboard] = useState({
  courses: 0,
  notes: 0,
});
const stats = [
  {
    id: 1,
    title: "My Courses",
    value: dashboard.courses,
    icon: BookOpen,
    color: "#6A88CE",
  },
  {
    id: 2,
    title: "Notes",
    value: dashboard.notes,
    icon: FileText,
    color: "#E4916D",
  },
];

  const pendingTasks = [
    {
      task: "Grade Math Test (Class 5-A)",
      due: "Today, 5:00 PM",
      completed: false,
    },
    { task: "Submit Monthly Report", due: "Tomorrow", completed: false },
    { task: "Prepare Syllabus for Term 2", due: "", completed: true },
  ];

  // useEffect(() => {
  //   console.log("this is log from the dashboard", loggedInTeacher);
  //   fetchDashboard();
  // }, []);
  useEffect(() => {
  console.log(loggedInTeacher);

  if (loggedInTeacher) {
    fetchDashboard();
  }
}, [loggedInTeacher]);

const fetchDashboard = async () => {

  if (!loggedInTeacher) return;

  try {

    const response = await axios.post(
      `${baseUrl}/teacher/dashboard/teacherDashboard`,
      {
        ngteacher_id: loggedInTeacher.id,
      }
    );

    setDashboard(response.data);

  } catch (error) {
    console.log(error);
  }
};
  return (
    <TeacherMasterLayout>
      {/* Topbar */}
      <header className="ta-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="ta-profile">👤</div>
      </header>
      <div className="tdx-dashboard">
        {/* Header */}
        <div className="tdx-header">
          <div className="tdx-user">
            {/* <img
              src="https://i.pravatar.cc/50"
              alt="avatar"
              className="tdx-avatar"
            /> */}
            <div>
              <span className="tdx-welcome">Welcome back</span>
              <h2 className="tdx-name">Teacher</h2>
            </div>
          </div>

          {/* Notification Bell */}
          <div
            className="tdx-bell"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FaBell />
          </div>

          {/* Notification Popup */}
          {showNotifications && (
            <div className="tdx-notification-popup">
              <h4>Notifications</h4>

              <ul>
                {notifications.map((note, i) => (
                  <li key={i}>{note}</li>
                ))}
              </ul>

              <button
                className="tdx-view-all-btn"
                onClick={() => navigate("/teacher/notification")}
              >
                View All Notifications
              </button>
            </div>
          )}
        </div>

        <p className="tdx-greeting">Good Morning, Ready for class?</p>
        <p className="tdx-date">Thursday, Oct 24th</p>

        {/* Attendance */}
        <div className="tdx-section">
          <h3 className="tdx-title">Dashboard Overview</h3>

          <div className="tdx-stats-grid">
            {stats.map((stat) => {
              const Icon = stat.icon;

              return (
                <div key={stat.id} className="tdx-stat-card">
                  <div className="tdx-stat-card-header">
                    <div
                      className="tdx-stat-card-icon"
                      style={{ backgroundColor: `${stat.color}15` }}
                    >
                      <Icon size={24} color={stat.color} />
                    </div>
                  </div>

                  <div className="tdx-stat-card-body">
                    <h3 className="tdx-stat-card-value">{stat.value}</h3>

                    <p className="tdx-stat-card-title">{stat.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <TeacherAttendanceGraph /> */}

        {/* Assigned Courses */}
        {/* <div className="tdx-section">
          <h3 className="tdx-title">Assigned Courses</h3>

          <div className="tdx-course-grid">
            {assignedCourses.map((course) => (
              <div
                key={course.id}
                className="tdx-course-card"
                style={{ background: course.color }}
              >
                <div className="tdx-course-top">
                  <span>{course.class}</span>
                  <FaCheckCircle />
                </div>

                <h4>{course.subject}</h4>
                <p>{course.location}</p>

                <div className="tdx-course-time">
                  <FaClock /> {course.time}
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Results */}
        {/* <div className="tdx-section">
          <h3 className="tdx-title">Uploaded Results</h3>

          <div className="tdx-result-card">
            <p>Term 1 Grading</p>
            <h4>3 / 4 Classes</h4>

            <div className="tdx-progress">
              <span style={{ width: "75%" }}></span>
            </div>

            <small>Updated 2 mins ago</small>

            <button className="tdx-upload-btn" onClick={()=>navigate("/teacher/result")}>
              Upload New <FaUpload />
            </button>
          </div>
        </div> */}

        {/* Tasks */}
        {/* <div className="tdx-section">
          <h3 className="tdx-title">
            Pending Tasks <span>(3 Left)</span>
          </h3>

          <div className="tdx-task-list">
            {pendingTasks.map((task, i) => (
              <label
                key={i}
                className={`tdx-task ${task.completed ? "done" : ""}`}
              >
                <input type="checkbox" checked={task.completed} readOnly />
                <div>
                  <p>{task.task}</p>
                  {task.due && <small>Due {task.due}</small>}
                </div>
              </label>
            ))}
          </div>
        </div> */}

        {/* Bottom Nav (PLUS REMOVED) */}
        {/* <div className="tdx-bottom-nav">
          <span className="active">Home</span>
          <span>Schedule</span>
          <span>Chat</span>
          <span>Settings</span>
        </div> */}
      </div>
    </TeacherMasterLayout>
  );
};

export default TeacherDashboard;
